export const latexData = {
  textFormatting: [
    '\\text{enter text here}',
    '\\textbf{enter text to be bold}',
    '\\textit{enter text to be italics}',
    '\\underline{\\text{enter text to be underline}}',
    '\\underline{\\textbf{bold and underline}}',
  ],
  chemistry: [
    'H_2O',
    'CO_2',
    'CO(g) + 3H_2(g) \\xrightarrow{\\text{Ni}} CH_4(g) + H_2O(g)',
    'K_\\text{eq} = \\frac{[{Products}]}{[{Reactants}]}',
    'Ca^{2+}',
    '[Cr(H_2O)_6]^{3+}',
  ],
  mathAndVectors: [
    'a + b = c',
    '5 \\times 6 = 30',
    '\\frac{1}{2}',
    '\\pi r^2',
    '\\vec{a}',
    '\\vec{a} + \\vec{b} = \\vec{c}',
    'ab \\sin \\theta \\, \\hat{n}',
    '\\vec{a} \\cdot \\vec{b}',
    '\\hat{i}, \\hat{j}, \\hat{k}',
    '\\vec{r} = x\\hat{i} + y\\hat{j} + z\\hat{k}',
    '\\text{Displacement} = \\vec{r}_2 - \\vec{r}_1',
    '\\text{Velocity} = \\frac{\\Delta \\vec{r}}{\\Delta t}',
    '\\text{Acceleration} = \\frac{\\Delta \\vec{v}}{\\Delta t}',
    '\\vec{F} = m \\vec{a}',
    '\\sum_{i=1}^{n} i = \\frac{n(n+1)}{2}',
    'x = \\frac{-b \\pm \\sqrt{b^2 - 4ac}}{2a}',
  ],
}

export const sections = {
  textFormatting: {
    title: 'Text Formatting',
    latexArray: latexData.textFormatting,
  },
  chemistry: {
    title: 'Chemistry',
    latexArray: latexData.chemistry,
  },
  mathAndVectors: {
    title: 'Math and Vectors',
    latexArray: latexData.mathAndVectors,
  },
}

export const clozeMathAnswerChoiceAddLatextHelpSections = [
  {
    ...sections.chemistry,
    useBackTicks: true,
  },
  {
    ...sections.mathAndVectors,
    useBackTicks: true,
  },
]

export const addLatextHelpSections = [
  sections.chemistry,
  sections.mathAndVectors,
]

export const dynamicParamsHelpLatexSections = [
  sections.textFormatting,
  sections.chemistry,
  sections.mathAndVectors,
]
